import { call, put, takeEvery } from "redux-saga/effects";
import { changePasswordDataRequest, changePasswordDataSuccess, changePasswordDataFailure } from "../slice/changePasswordSlice";
import api from "../../../config/api";
import { config } from "../../../config/global";
const API_URL = config?.ROPP_CHANGE_PASSWORD_API;
const fetchChangePin = async changePinPayload => {
  let data = {
    mode: "no-cors",
    headers: {
      "content-type": "application/json",
      "Access-Control-Expose-Headers": "accessToken",
      "App-Authorization": localStorage.getItem("accesstoken") || ""
    },
    isGenericErr: false
  };
  let changePinPayloadData = {
    oldPin: changePinPayload.oldPin,
    newPin: changePinPayload.newPin
  };
  const response = await api.post(API_URL, changePinPayloadData, data);
  if (response) {
    sessionStorage.setItem("refNumber", response?.data.otpRefKey);
    sessionStorage.setItem("newPin", changePinPayload.newPin);
    sessionStorage.setItem("oldPin", changePinPayload.oldPin);
  }
  return response;
};
function* fetchChangePinSaga(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchChangePin, payload);
    yield put(changePasswordDataSuccess({
      ...response
    }));
  } catch (error) {
    yield put(changePasswordDataFailure({
      ...error
    }));
  }
}
export function* watchChangePin() {
  yield takeEvery(changePasswordDataRequest.type, fetchChangePinSaga);
}